import { render, staticRenderFns } from "./layer-invoice.vue?vue&type=template&id=047e6274&scoped=true&"
import script from "./layer-invoice.vue?vue&type=script&lang=js&"
export * from "./layer-invoice.vue?vue&type=script&lang=js&"
import style0 from "./layer-invoice.vue?vue&type=style&index=0&id=047e6274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e6274",
  null
  
)

export default component.exports